import { NavLink } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SOCIAL_LINKS } from "@/data/menzy";
import { toast } from "sonner";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.5c-1.3.1-2.5-.2-3.6-.9v5.6c0 3.2-2.3 5.4-5.2 5.4A5.1 5.1 0 0 1 6 14.4c0-2.9 2.3-5.1 5.2-5.1.4 0 .8 0 1.2.1v2.7c-.3-.1-.6-.2-1-.2-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5c1.4 0 2.6-1 2.6-2.9V3h2.5Z" />
  </svg>
);

const socials = [
  { key: "instagram", label: "Instagram", Icon: Instagram },
  { key: "tiktok", label: "TikTok", Icon: TikTokIcon },
  { key: "facebook", label: "Facebook", Icon: Facebook },
];

export const Footer = () => {
  const handleSocial = (key) => {
    const url = SOCIAL_LINKS[key];
    if (url) window.open(url, "_blank", "noopener,noreferrer");
    else toast("Link coming soon", { description: `MENZY's ${key} will be added shortly.` });
  };

  return (
    <footer className="relative border-t border-[#d4af37]/20 bg-[#0b0b0c] pt-12 pb-24 sm:pb-10">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 items-start">
          <div className="md:col-span-1">
            <Logo size="md" />
            <p className="mt-4 text-sm text-white/60 leading-relaxed">
              Clean Cuts. Confident You.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-[#d4af37] font-semibold mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <NavLink to="/" end className="text-white/75 hover:text-[#f4d160] transition-colors text-sm" data-testid="footer-home-link">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/bookings" className="text-white/75 hover:text-[#f4d160] transition-colors text-sm" data-testid="footer-bookings-link">
                  Bookings
                </NavLink>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-[#d4af37] font-semibold mb-4">
              Follow
            </h4>
            <div className="flex items-center gap-3">
              {socials.map(({ key, label, Icon }) => (
                <button
                  key={key}
                  onClick={() => handleSocial(key)}
                  data-testid={`footer-social-${key}`}
                  aria-label={label}
                  className="h-11 w-11 rounded-full border border-[#d4af37]/40 flex items-center justify-center text-white/80 hover:text-[#0b0b0c] hover:bg-[#d4af37] hover:border-[#d4af37] transition-colors duration-300"
                >
                  <Icon className="h-5 w-5" />
                </button>
              ))}
            </div>
          </div>

          <div className="flex md:justify-end">
            <p className="font-script text-3xl sm:text-4xl text-[#f4d160] leading-tight -rotate-2">
              A Fresh Cut,
              <br />A Better You
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/45">© {new Date().getFullYear()} MENZY (Master Barber).{" "}
            <a href="https://launchbs.com" target="_blank" rel="noopener noreferrer" data-testid="footer-launchbs-link" className="text-[#f4d160] hover:underline">Launchbs.com</a>
          </p>
          <p className="text-xs tracking-[0.3em] uppercase text-[#d4af37]/70">Clean Cuts. Confident You.</p>
        </div>
      </div>
    </footer>
  );
};
